import popSound from '../../assets/sounds/pop.mp3';

// reuse audio object instead on creating new one each time
const audio = new Audio(popSound);

const playPopSound = () => {
  audio.volume = 1;
  audio.play();
};

export default playPopSound;
